module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAXCAYAAAARIY8tAAABQElEQVRIicWV4W2DMBCFPyoWIAtYYoVkhGQEOgIdoR0hjFBGaEYII9QrZISwQn5wjg/XDlAi5UnI8PR8dz4/48wYQwQF8Ak0QK/4WsZ2hhaAt1h0YC+T9gFfqyRTWgDyoAqHUsYK2AbVAhxnaBugdwnOMjlcYqkC6ASxarW2EM0uM8YUwBX4wPe2An6Ad+CkgvzKuFNcTFsD38AmV0JdvVWPRhepPKa9x8r/yAdcgiodvhZogbSLnobUCkq8HS1Db7VLYlzLsJpZCbZ42zYSbIqzSxL0+E3rF3IjaJuGlnSe7//BOetuUptcSdIr/tQeJ7gqFuhlLuoYWga+x616j3GxQ5hMUDD+cV3k+xFniWz0y2xqJYh7X8KN8MimazBp06dBt6jEH5q1uF9SmVz6ZxJ36gp0wMGt4EDiJK7ACeAGZH9jZqZwF9YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/new/icon-calendar.png
// module id = 731
// module chunks = 0